import { afterNextRender, Component, inject, signal } from '@angular/core';
import { GetVersionGQL } from '@features/dashboard/queries/GetVersion.gql';
import { APP_VERSION } from '../../../environments/version';

@Component({
    selector: 'version-badge',
    template: '<span class="version-badge">FE {{ feVersion }} | BE {{ beVersion() }}</span>',
    styleUrls: ['./version-badge.component.scss'],
})
export class VersionBadgeComponent {
    readonly feVersion = APP_VERSION;
    readonly beVersion = signal('...');

    private readonly versionQuery = inject(GetVersionGQL);

    constructor() {
        afterNextRender(() => {
            this.versionQuery
                .fetch({ context: { requireAuth: false } })
                .subscribe(r => this.beVersion.set(r.data?.version || '?'));
        });
    }
}
